import type { TablePaginationConfig } from "antd/es/table";
import { showTotal } from "./show-total";

export const DEFAULT_PAGINATION: TablePaginationConfig = {
  total: 0,
  current: 1,
  pageSize: 10,
  defaultPageSize: 10,
  position: ["bottomRight"],
  showSizeChanger: false,
  hideOnSinglePage: true,
  showTotal,
};
